import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { contratosService, inmueblesService, inquilinosService, garantesService, inmobiliariasService, aiService } from '../services/api';
import Documentos from '../components/Documentos';

const CONTRATO_VACIO = {
  inmueble_id: '', inquilino_id: '', nuevoInquilino: false,
  inq_nombre: '', inq_apellido: '', inq_documento: '', inq_email: '', inq_telefono: '', inq_tipo: 'persona_fisica',
  garante_id: '', nuevoGarante: false,
  gar_nombre: '', gar_apellido: '', gar_documento: '', gar_telefono: '',
  tipo: 'alquiler', moneda: 'USD', monto: '', deposito: '', moneda_deposito: 'USD',
  fecha_inicio: '', fecha_fin: '', duracion_meses: '', dia_vencimiento: '5',
  indexacion: 'ninguna', porcentaje_indexacion: '', inmobiliaria: '',
  comision_inmobiliaria: '', moneda_comision: 'USD', notas: ''
};

function ModalContratoManual({ inmuebles, inquilinos, garantes, listaInmobiliarias, onClose, onGuardado }) {
  const [form, setForm] = useState(CONTRATO_VACIO);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  const set = (field, val) => setForm(f => ({ ...f, [field]: val }));
  const handle = e => set(e.target.name, e.target.type === 'checkbox' ? e.target.checked : e.target.value);

  // Auto-calcular fecha_fin cuando cambia fecha_inicio o duracion_meses
  const calcFechaFin = (inicio, meses) => {
    if (!inicio || !meses) return '';
    const d = new Date(inicio);
    d.setMonth(d.getMonth() + parseInt(meses));
    return d.toISOString().split('T')[0];
  };

  const handleFechaODuracion = e => {
    const { name, value } = e.target;
    const nuevo = { ...form, [name]: value };
    if (name === 'fecha_inicio' || name === 'duracion_meses') {
      const inicio = name === 'fecha_inicio' ? value : form.fecha_inicio;
      const meses = name === 'duracion_meses' ? value : form.duracion_meses;
      nuevo.fecha_fin = calcFechaFin(inicio, meses);
    }
    setForm(nuevo);
  };

  const handleGuardar = async e => {
    e.preventDefault();
    if (!form.inmueble_id) { setError('Seleccioná un inmueble'); return; }
    if (!form.nuevoInquilino && !form.inquilino_id) { setError('Seleccioná o ingresá un inquilino'); return; }
    if (!form.monto) { setError('Ingresá el monto'); return; }
    if (!form.fecha_inicio) { setError('Ingresá la fecha de inicio'); return; }
    setGuardando(true);
    setError('');
    try {
      let inquilino_id = form.inquilino_id;
      if (form.nuevoInquilino) {
        const r = await inquilinosService.create({
          tipo: form.inq_tipo, nombre: form.inq_nombre, apellido: form.inq_apellido,
          documento: form.inq_documento, email: form.inq_email, telefono: form.inq_telefono
        });
        inquilino_id = r.data.id;
      }

      let garante_id = form.garante_id || null;
      if (form.nuevoGarante && form.gar_nombre) {
        const r = await garantesService.create({
          nombre: form.gar_nombre, apellido: form.gar_apellido,
          documento: form.gar_documento, telefono: form.gar_telefono
        });
        garante_id = r.data.id;
      }

      await contratosService.create({
        inmueble_id: form.inmueble_id, inquilino_id, garante_id,
        tipo: form.tipo, moneda: form.moneda, monto: form.monto,
        deposito: form.deposito || null, moneda_deposito: form.moneda_deposito,
        fecha_inicio: form.fecha_inicio, fecha_fin: form.fecha_fin || null,
        duracion_meses: form.duracion_meses || null, dia_vencimiento: form.dia_vencimiento,
        indexacion: form.indexacion, porcentaje_indexacion: form.porcentaje_indexacion || null,
        inmobiliaria: form.inmobiliaria || null,
        comision_inmobiliaria: form.comision_inmobiliaria || null,
        moneda_comision: form.moneda_comision,
        notas: form.notas || null
      });
      onGuardado();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al guardar');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ width: 720, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2>📋 Nuevo contrato manual</h2>
          <button className="btn btn-secondary" style={{ fontSize: '0.82rem' }} onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleGuardar}>
          {/* Inmueble */}
          <section style={{ marginBottom: 20 }}>
            <h3 style={{ fontSize: '0.9rem', color: '#1a1a2e', marginBottom: 10, borderBottom: '1px solid #f0f0f0', paddingBottom: 6 }}>🏠 Inmueble</h3>
            <div className="form-group">
              <label>Inmueble *</label>
              <select name="inmueble_id" value={form.inmueble_id} onChange={handle}>
                <option value="">-- Seleccioná --</option>
                {inmuebles.map(i => <option key={i.id} value={i.id}>{i.nombre} — {i.direccion}</option>)}
              </select>
            </div>
          </section>

          {/* Inquilino */}
          <section style={{ marginBottom: 20 }}>
            <h3 style={{ fontSize: '0.9rem', color: '#1a1a2e', marginBottom: 10, borderBottom: '1px solid #f0f0f0', paddingBottom: 6 }}>👤 Inquilino</h3>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <button type="button" className="btn" onClick={() => set('nuevoInquilino', false)}
                style={{ background: !form.nuevoInquilino ? '#1a1a2e' : '#f0f0f0', color: !form.nuevoInquilino ? 'white' : '#555', fontSize: '0.82rem', padding: '6px 14px' }}>
                Existente
              </button>
              <button type="button" className="btn" onClick={() => set('nuevoInquilino', true)}
                style={{ background: form.nuevoInquilino ? '#1a1a2e' : '#f0f0f0', color: form.nuevoInquilino ? 'white' : '#555', fontSize: '0.82rem', padding: '6px 14px' }}>
                + Nuevo
              </button>
            </div>
            {!form.nuevoInquilino ? (
              <div className="form-group">
                <label>Seleccioná inquilino *</label>
                <select name="inquilino_id" value={form.inquilino_id} onChange={handle}>
                  <option value="">-- Seleccioná --</option>
                  {inquilinos.map(i => <option key={i.id} value={i.id}>{i.nombre} {i.apellido} {i.documento ? `— ${i.documento}` : ''}</option>)}
                </select>
              </div>
            ) : (
              <div className="form-grid">
                <div className="form-group">
                  <label>Tipo</label>
                  <select name="inq_tipo" value={form.inq_tipo} onChange={handle}>
                    <option value="persona_fisica">Persona física</option>
                    <option value="empresa">Empresa</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Nombre *</label>
                  <input name="inq_nombre" value={form.inq_nombre} onChange={handle} />
                </div>
                <div className="form-group">
                  <label>Apellido</label>
                  <input name="inq_apellido" value={form.inq_apellido} onChange={handle} />
                </div>
                <div className="form-group">
                  <label>CI / RUT</label>
                  <input name="inq_documento" value={form.inq_documento} onChange={handle} />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input name="inq_email" type="email" value={form.inq_email} onChange={handle} />
                </div>
                <div className="form-group">
                  <label>Teléfono</label>
                  <input name="inq_telefono" value={form.inq_telefono} onChange={handle} />
                </div>
              </div>
            )}
          </section>

          {/* Garante */}
          <section style={{ marginBottom: 20 }}>
            <h3 style={{ fontSize: '0.9rem', color: '#1a1a2e', marginBottom: 10, borderBottom: '1px solid #f0f0f0', paddingBottom: 6 }}>🛡 Garante <span style={{ fontWeight: 400, color: '#aaa' }}>(opcional)</span></h3>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <button type="button" className="btn" onClick={() => { set('nuevoGarante', false); set('garante_id', ''); }}
                style={{ background: !form.nuevoGarante ? '#1a1a2e' : '#f0f0f0', color: !form.nuevoGarante ? 'white' : '#555', fontSize: '0.82rem', padding: '6px 14px' }}>
                Existente / Sin garante
              </button>
              <button type="button" className="btn" onClick={() => set('nuevoGarante', true)}
                style={{ background: form.nuevoGarante ? '#1a1a2e' : '#f0f0f0', color: form.nuevoGarante ? 'white' : '#555', fontSize: '0.82rem', padding: '6px 14px' }}>
                + Nuevo
              </button>
            </div>
            {!form.nuevoGarante ? (
              <div className="form-group">
                <label>Seleccioná garante</label>
                <select name="garante_id" value={form.garante_id} onChange={handle}>
                  <option value="">Sin garante</option>
                  {garantes.map(g => <option key={g.id} value={g.id}>{g.nombre} {g.apellido || ''} {g.documento ? `— ${g.documento}` : ''}</option>)}
                </select>
              </div>
            ) : (
              <div className="form-grid">
                <div className="form-group">
                  <label>Nombre *</label>
                  <input name="gar_nombre" value={form.gar_nombre} onChange={handle} />
                </div>
                <div className="form-group">
                  <label>Apellido</label>
                  <input name="gar_apellido" value={form.gar_apellido} onChange={handle} />
                </div>
                <div className="form-group">
                  <label>CI</label>
                  <input name="gar_documento" value={form.gar_documento} onChange={handle} />
                </div>
                <div className="form-group">
                  <label>Teléfono</label>
                  <input name="gar_telefono" value={form.gar_telefono} onChange={handle} />
                </div>
              </div>
            )}
          </section>

          {/* Datos del contrato */}
          <section style={{ marginBottom: 20 }}>
            <h3 style={{ fontSize: '0.9rem', color: '#1a1a2e', marginBottom: 10, borderBottom: '1px solid #f0f0f0', paddingBottom: 6 }}>💵 Condiciones económicas</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Moneda *</label>
                <select name="moneda" value={form.moneda} onChange={handle}>
                  <option value="USD">USD</option>
                  <option value="UYU">UYU</option>
                </select>
              </div>
              <div className="form-group">
                <label>Monto mensual *</label>
                <input name="monto" type="number" value={form.monto} onChange={handle} />
              </div>
              <div className="form-group">
                <label>Moneda depósito</label>
                <select name="moneda_deposito" value={form.moneda_deposito} onChange={handle}>
                  <option value="USD">USD</option>
                  <option value="UYU">UYU</option>
                </select>
              </div>
              <div className="form-group">
                <label>Depósito</label>
                <input name="deposito" type="number" value={form.deposito} onChange={handle} />
              </div>
              <div className="form-group">
                <label>Indexación</label>
                <select name="indexacion" value={form.indexacion} onChange={handle}>
                  <option value="ninguna">Ninguna</option>
                  <option value="IPC">IPC</option>
                  <option value="ICR">ICR</option>
                  <option value="fijo">Fijo</option>
                </select>
              </div>
              <div className="form-group">
                <label>% Indexación</label>
                <input name="porcentaje_indexacion" type="number" value={form.porcentaje_indexacion} onChange={handle} />
              </div>
            </div>
          </section>

          <section style={{ marginBottom: 20 }}>
            <h3 style={{ fontSize: '0.9rem', color: '#1a1a2e', marginBottom: 10, borderBottom: '1px solid #f0f0f0', paddingBottom: 6 }}>📅 Plazos</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Fecha inicio *</label>
                <input name="fecha_inicio" type="date" value={form.fecha_inicio} onChange={handleFechaODuracion} />
              </div>
              <div className="form-group">
                <label>Duración (meses)</label>
                <input name="duracion_meses" type="number" value={form.duracion_meses} onChange={handleFechaODuracion} placeholder="Ej: 12" />
              </div>
              <div className="form-group">
                <label>Fecha fin</label>
                <input name="fecha_fin" type="date" value={form.fecha_fin} onChange={handle} />
              </div>
              <div className="form-group">
                <label>Día de pago</label>
                <input name="dia_vencimiento" type="number" value={form.dia_vencimiento} onChange={handle} min="1" max="28" />
              </div>
            </div>
          </section>

          <section style={{ marginBottom: 20 }}>
            <h3 style={{ fontSize: '0.9rem', color: '#1a1a2e', marginBottom: 10, borderBottom: '1px solid #f0f0f0', paddingBottom: 6 }}>🏢 Inmobiliaria</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Inmobiliaria</label>
                <select name="inmobiliaria" value={form.inmobiliaria} onChange={handle}>
                  <option value="">Sin inmobiliaria</option>
                  {listaInmobiliarias.map(i => <option key={i.id} value={i.nombre}>{i.nombre}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Comisión</label>
                <input name="comision_inmobiliaria" type="number" value={form.comision_inmobiliaria} onChange={handle} />
              </div>
              <div className="form-group">
                <label>Moneda comisión</label>
                <select name="moneda_comision" value={form.moneda_comision} onChange={handle}>
                  <option value="USD">USD</option>
                  <option value="UYU">UYU</option>
                </select>
              </div>
            </div>
          </section>

          <section style={{ marginBottom: 20 }}>
            <div className="form-group">
              <label>Notas</label>
              <textarea name="notas" value={form.notas} onChange={handle} rows={3} />
            </div>
          </section>

          {error && <div style={{ color: '#e74c3c', fontSize: '0.85rem', marginBottom: 12 }}>⚠️ {error}</div>}

          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={guardando} style={{ minWidth: 140 }}>
              {guardando ? '⏳ Guardando...' : '💾 Guardar contrato'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const ESTADO_COLORS = {
  activo: { bg: '#eafaf1', color: '#27ae60' },
  vencido: { bg: '#fdecea', color: '#e74c3c' },
  rescindido: { bg: '#f0f0f0', color: '#95a5a6' },
  renovado: { bg: '#eaf2ff', color: '#4f8ef7' },
};

function diasParaVencer(fecha_fin) {
  if (!fecha_fin) return null;
  const hoy = new Date();
  const fin = new Date(fecha_fin);
  return Math.ceil((fin - hoy) / (1000 * 60 * 60 * 24));
}

// Paso 1: seleccionar PDF
function ModalSubirPDF({ onClose, onDatosExtraidos }) {
  const [archivo, setArchivo] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const inputRef = useRef();

  const handleArchivo = e => {
    const f = e.target.files[0];
    if (f && f.type === 'application/pdf') {
      setArchivo(f);
      setError('');
    } else {
      setError('Solo se aceptan archivos PDF');
    }
  };

  const handleAnalizar = async () => {
    if (!archivo) return;
    setCargando(true);
    setError('');
    try {
      const fd = new FormData();
      fd.append('pdf', archivo);
      const res = await aiService.leerContrato(fd);
      onDatosExtraidos(res.data.datos, archivo);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al analizar el PDF');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ width: 480 }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2>📄 Cargar contrato con IA</h2>
          <button className="btn btn-secondary" style={{ fontSize: '0.82rem' }} onClick={onClose}>✕</button>
        </div>

        <p style={{ fontSize: '0.88rem', color: '#666', marginBottom: 20 }}>
          Subí el PDF del contrato de arrendamiento y Claude va a extraer automáticamente todos los datos.
        </p>

        <div
          onClick={() => inputRef.current.click()}
          style={{
            border: '2px dashed #d0d0d0', borderRadius: 10, padding: '32px 20px',
            textAlign: 'center', cursor: 'pointer', marginBottom: 16,
            background: archivo ? '#f0fff4' : '#fafafa',
            borderColor: archivo ? '#27ae60' : '#d0d0d0'
          }}>
          <input ref={inputRef} type="file" accept=".pdf" style={{ display: 'none' }} onChange={handleArchivo} />
          {archivo ? (
            <>
              <div style={{ fontSize: '2rem' }}>✅</div>
              <div style={{ fontWeight: 600, color: '#27ae60', marginTop: 6 }}>{archivo.name}</div>
              <div style={{ fontSize: '0.78rem', color: '#888', marginTop: 2 }}>
                {(archivo.size / 1024).toFixed(1)} KB
              </div>
            </>
          ) : (
            <>
              <div style={{ fontSize: '2rem' }}>📁</div>
              <div style={{ color: '#888', marginTop: 6 }}>Hacé clic para seleccionar el PDF</div>
            </>
          )}
        </div>

        {error && (
          <div style={{ color: '#e74c3c', fontSize: '0.85rem', marginBottom: 12, background: '#fdecea', borderRadius: 8, padding: '10px 14px', lineHeight: 1.5 }}>
            ⚠️ {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button
            className="btn btn-primary"
            onClick={handleAnalizar}
            disabled={!archivo || cargando}
            style={{ minWidth: 140 }}>
            {cargando ? '⏳ Analizando...' : '🤖 Analizar con IA'}
          </button>
        </div>
      </div>
    </div>
  );
}

// Paso 2: confirmar datos extraídos
function ModalConfirmar({ datos, archivo, inmuebles, listaInmobiliarias, onClose, onConfirmado }) {
  const [form, setForm] = useState({
    inmueble_id: '',
    inquilino: { ...datos.inquilino },
    garante: datos.garante?.nombre ? { ...datos.garante } : null,
    contrato: { ...datos.contrato },
  });
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  const setInq = (field, val) => setForm(f => ({ ...f, inquilino: { ...f.inquilino, [field]: val } }));
  const setCon = (field, val) => setForm(f => ({ ...f, contrato: { ...f.contrato, [field]: val } }));
  const setGar = (field, val) => setForm(f => ({ ...f, garante: { ...(f.garante || {}), [field]: val } }));

  const handleConfirmar = async () => {
    if (!form.inmueble_id) { setError('Seleccioná el inmueble'); return; }
    setGuardando(true);
    setError('');
    try {
      const fd = new FormData();
      if (archivo) fd.append('pdf', archivo);
      fd.append('datos', JSON.stringify({
        inmueble_id: form.inmueble_id,
        inquilino: form.inquilino,
        garante: form.garante,
        contrato: form.contrato,
      }));
      await aiService.confirmarContrato(fd);
      onConfirmado();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al guardar');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ width: 720, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2>✅ Confirmar datos del contrato</h2>
          <button className="btn btn-secondary" style={{ fontSize: '0.82rem' }} onClick={onClose}>✕</button>
        </div>

        <p style={{ fontSize: '0.85rem', color: '#888', marginBottom: 20 }}>
          Claude extrajo los siguientes datos. Revisá y corregí lo que sea necesario antes de guardar.
        </p>

        {/* Inmueble */}
        <section style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: '0.9rem', color: '#1a1a2e', marginBottom: 10, borderBottom: '1px solid #f0f0f0', paddingBottom: 6 }}>
            🏠 Inmueble
          </h3>
          <div className="form-group">
            <label>Seleccioná el inmueble *</label>
            <select value={form.inmueble_id} onChange={e => setForm(f => ({ ...f, inmueble_id: e.target.value }))}>
              <option value="">-- Seleccioná --</option>
              {inmuebles.map(i => (
                <option key={i.id} value={i.id}>{i.nombre} — {i.direccion}</option>
              ))}
            </select>
          </div>
          {datos.inmueble?.direccion && (
            <p style={{ fontSize: '0.82rem', color: '#888', marginTop: 4 }}>
              📍 Claude detectó: <em>{datos.inmueble.direccion}, {datos.inmueble.ciudad}</em>
            </p>
          )}
        </section>

        {/* Inquilino */}
        <section style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: '0.9rem', color: '#1a1a2e', marginBottom: 10, borderBottom: '1px solid #f0f0f0', paddingBottom: 6 }}>
            👤 Inquilino
          </h3>
          <div className="form-grid">
            <div className="form-group">
              <label>Nombre</label>
              <input value={form.inquilino.nombre || ''} onChange={e => setInq('nombre', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Apellido</label>
              <input value={form.inquilino.apellido || ''} onChange={e => setInq('apellido', e.target.value)} />
            </div>
            <div className="form-group">
              <label>CI / RUT</label>
              <input value={form.inquilino.documento || ''} onChange={e => setInq('documento', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Tipo</label>
              <select value={form.inquilino.tipo || 'persona_fisica'} onChange={e => setInq('tipo', e.target.value)}>
                <option value="persona_fisica">Persona física</option>
                <option value="empresa">Empresa</option>
              </select>
            </div>
            <div className="form-group">
              <label>Email</label>
              <input value={form.inquilino.email || ''} onChange={e => setInq('email', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Teléfono</label>
              <input value={form.inquilino.telefono || ''} onChange={e => setInq('telefono', e.target.value)} />
            </div>
          </div>
        </section>

        {/* Garante */}
        {form.garante && (
          <section style={{ marginBottom: 20 }}>
            <h3 style={{ fontSize: '0.9rem', color: '#1a1a2e', marginBottom: 10, borderBottom: '1px solid #f0f0f0', paddingBottom: 6 }}>
              🛡 Garante
            </h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Nombre</label>
                <input value={form.garante.nombre || ''} onChange={e => setGar('nombre', e.target.value)} />
              </div>
              <div className="form-group">
                <label>Apellido</label>
                <input value={form.garante.apellido || ''} onChange={e => setGar('apellido', e.target.value)} />
              </div>
              <div className="form-group">
                <label>CI</label>
                <input value={form.garante.documento || ''} onChange={e => setGar('documento', e.target.value)} />
              </div>
              <div className="form-group">
                <label>Teléfono</label>
                <input value={form.garante.telefono || ''} onChange={e => setGar('telefono', e.target.value)} />
              </div>
            </div>
          </section>
        )}

        {/* Contrato */}
        <section style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: '0.9rem', color: '#1a1a2e', marginBottom: 10, borderBottom: '1px solid #f0f0f0', paddingBottom: 6 }}>
            📋 Datos del contrato
          </h3>
          <div className="form-grid">
            <div className="form-group">
              <label>Moneda</label>
              <select value={form.contrato.moneda || 'USD'} onChange={e => setCon('moneda', e.target.value)}>
                <option value="USD">USD</option>
                <option value="UYU">UYU</option>
              </select>
            </div>
            <div className="form-group">
              <label>Monto mensual</label>
              <input type="number" value={form.contrato.monto || ''} onChange={e => setCon('monto', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Fecha inicio</label>
              <input type="date" value={form.contrato.fecha_inicio || ''} onChange={e => setCon('fecha_inicio', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Fecha fin</label>
              <input type="date" value={form.contrato.fecha_fin || ''} onChange={e => setCon('fecha_fin', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Duración (meses)</label>
              <input type="number" value={form.contrato.duracion_meses || ''} onChange={e => setCon('duracion_meses', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Día de pago</label>
              <input type="number" value={form.contrato.dia_vencimiento || 5} onChange={e => setCon('dia_vencimiento', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Moneda depósito</label>
              <select value={form.contrato.moneda_deposito || 'USD'} onChange={e => setCon('moneda_deposito', e.target.value)}>
                <option value="USD">USD</option>
                <option value="UYU">UYU</option>
              </select>
            </div>
            <div className="form-group">
              <label>Depósito</label>
              <input type="number" value={form.contrato.deposito || ''} onChange={e => setCon('deposito', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Indexación</label>
              <select value={form.contrato.indexacion || 'ninguna'} onChange={e => setCon('indexacion', e.target.value)}>
                <option value="ninguna">Ninguna</option>
                <option value="IPC">IPC</option>
                <option value="ICR">ICR</option>
                <option value="fijo">Fijo</option>
              </select>
            </div>
            <div className="form-group">
              <label>% Indexación</label>
              <input type="number" value={form.contrato.porcentaje_indexacion || ''} onChange={e => setCon('porcentaje_indexacion', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Inmobiliaria</label>
              <select value={form.contrato.inmobiliaria || ''} onChange={e => setCon('inmobiliaria', e.target.value)}>
                <option value="">Sin inmobiliaria</option>
                {listaInmobiliarias.map(i => <option key={i.id} value={i.nombre}>{i.nombre}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Comisión inmobiliaria</label>
              <input type="number" value={form.contrato.comision_inmobiliaria || ''} onChange={e => setCon('comision_inmobiliaria', e.target.value)} />
            </div>
            <div className="form-group full">
              <label>Notas</label>
              <textarea rows={3} value={form.contrato.notas || ''} onChange={e => setCon('notas', e.target.value)} />
            </div>
          </div>
        </section>

        {archivo && (
          <div style={{ fontSize: '0.82rem', color: '#27ae60', marginBottom: 12 }}>
            📎 Se adjuntará el PDF: <strong>{archivo.name}</strong>
          </div>
        )}

        {error && <div style={{ color: '#e74c3c', fontSize: '0.85rem', marginBottom: 12 }}>⚠️ {error}</div>}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button
            className="btn btn-primary"
            onClick={handleConfirmar}
            disabled={guardando}
            style={{ minWidth: 160 }}>
            {guardando ? '⏳ Guardando...' : '✅ Confirmar y guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Contratos() {
  const navigate = useNavigate();
  const [contratos, setContratos] = useState([]);
  const [inmuebles, setInmuebles] = useState([]);
  const [inquilinos, setInquilinos] = useState([]);
  const [garantes, setGarantes] = useState([]);
  const [listaInmobiliarias, setListaInmobiliarias] = useState([]);
  const [filtro, setFiltro] = useState('activo');
  const [filtroInmobiliaria, setFiltroInmobiliaria] = useState('todas');
  const [detalle, setDetalle] = useState(null);
  const [modalManual, setModalManual] = useState(false);
  const [pasoIA, setPasoIA] = useState(null); // null | 'subir' | 'confirmar'
  const [datosIA, setDatosIA] = useState(null);
  const [archivoIA, setArchivoIA] = useState(null);
  const [vistaLista, setVistaLista] = useState(false);

  const cargar = () => {
    contratosService.getAll().then(r => setContratos(r.data));
    inmueblesService.getAll().then(r => setInmuebles(r.data));
    inquilinosService.getAll().then(r => setInquilinos(r.data));
    garantesService.getAll().then(r => setGarantes(r.data));
    inmobiliariasService.getAll().then(r => setListaInmobiliarias(r.data));
  };
  useEffect(() => { cargar(); }, []);

  const activos = contratos.filter(c => c.estado === 'activo');
  const porVencer = activos.filter(c => {
    const dias = diasParaVencer(c.fecha_fin);
    return dias !== null && dias <= 60;
  }).length;

  const totalUSD = activos.filter(c => c.moneda === 'USD').reduce((sum, c) => sum + parseFloat(c.monto || 0), 0);
  const totalUYU = activos.filter(c => c.moneda === 'UYU').reduce((sum, c) => sum + parseFloat(c.monto || 0), 0);

  const inmobiliarias = ['todas', ...new Set(contratos.map(c => c.inmobiliaria).filter(Boolean))];

  const contratosFiltrados = contratos
    .filter(c => filtro === 'todos' || c.estado === filtro)
    .filter(c => filtroInmobiliaria === 'todas' || c.inmobiliaria === filtroInmobiliaria);

  const handleDatosExtraidos = (datos, archivo) => {
    setDatosIA(datos);
    setArchivoIA(archivo);
    setPasoIA('confirmar');
  };

  const handleConfirmado = () => {
    setPasoIA(null);
    setDatosIA(null);
    setArchivoIA(null);
    cargar();
  };

  return (
    <div>
      <div className="page-header">
        <h1>Contratos</h1>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <div className="view-toggle">
            <button className={!vistaLista ? 'active' : ''} onClick={() => setVistaLista(false)} title="Vista tarjetas">▦ Tarjetas</button>
            <button className={vistaLista ? 'active' : ''} onClick={() => setVistaLista(true)} title="Vista lista">☰ Lista</button>
          </div>
          <button className="btn btn-secondary" onClick={() => setModalManual(true)}>
            📋 Carga manual
          </button>
          <button className="btn btn-primary" onClick={() => setPasoIA('subir')}>
            🤖 Cargar con IA
          </button>
        </div>
      </div>

      {/* Stats */}
      <div className="stats-grid" style={{ marginBottom: 24 }}>
        <div className="stat-card">
          <div className="number" style={{ color: '#27ae60' }}>{activos.length}</div>
          <div className="label">Contratos activos</div>
        </div>
        <div className="stat-card">
          <div className="number" style={{ color: '#e74c3c' }}>{porVencer}</div>
          <div className="label">Por vencer (60 días)</div>
        </div>
        <div className="stat-card">
          <div className="number">{contratos.length}</div>
          <div className="label">Total contratos</div>
        </div>
        {totalUSD > 0 && (
          <div className="stat-card">
            <div className="number" style={{ color: '#2ecc71', fontSize: '1.4rem' }}>
              USD {totalUSD.toLocaleString()}
            </div>
            <div className="label">Ingresos activos / mes</div>
          </div>
        )}
        {totalUYU > 0 && (
          <div className="stat-card">
            <div className="number" style={{ color: '#3498db', fontSize: '1.4rem' }}>
              $ {totalUYU.toLocaleString()}
            </div>
            <div className="label">Ingresos activos / mes</div>
          </div>
        )}
      </div>

      {/* Filtros de estado */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        {['activo', 'vencido', 'rescindido', 'todos'].map(f => (
          <button key={f} onClick={() => setFiltro(f)}
            className="btn"
            style={{
              background: filtro === f ? '#1a1a2e' : '#f0f0f0',
              color: filtro === f ? 'white' : '#555',
              fontSize: '0.85rem', padding: '7px 16px'
            }}>
            {f === 'activo' ? 'Activos' : f === 'vencido' ? 'Vencidos' : f === 'rescindido' ? 'Rescindidos' : 'Todos'}
          </button>
        ))}
      </div>

      {/* Filtro por inmobiliaria */}
      {inmobiliarias.length > 1 && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ fontSize: '0.82rem', color: '#888', marginRight: 4 }}>Inmobiliaria:</span>
          {inmobiliarias.map(inm => (
            <button key={inm} onClick={() => setFiltroInmobiliaria(inm)}
              className="btn"
              style={{
                background: filtroInmobiliaria === inm ? '#4f8ef7' : '#f0f0f0',
                color: filtroInmobiliaria === inm ? 'white' : '#555',
                fontSize: '0.82rem', padding: '5px 14px'
              }}>
              {inm === 'todas' ? 'Todas' : inm}
            </button>
          ))}
        </div>
      )}

      {/* Lista */}
      {contratosFiltrados.length === 0 ? (
        <div className="empty-state">
          <h3>No hay contratos</h3>
          <p>Usá el botón "Cargar contrato con IA" para agregar contratos desde un PDF</p>
        </div>
      ) : vistaLista ? (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Inmueble</th>
                <th>Estado</th>
                <th>Inquilino</th>
                <th>Monto</th>
                <th>Inicio</th>
                <th>Vencimiento</th>
                <th>Inmobiliaria</th>
              </tr>
            </thead>
            <tbody>
              {contratosFiltrados.map(c => {
                const dias = diasParaVencer(c.fecha_fin);
                const alertaVencimiento = c.estado === 'activo' && dias !== null && dias <= 60;
                const estilo = ESTADO_COLORS[c.estado] || ESTADO_COLORS.activo;
                return (
                  <tr key={c.id} style={{ cursor: 'pointer' }} onClick={() => setDetalle(c)}>
                    <td><strong>{c.inmueble_nombre}</strong></td>
                    <td>
                      <span style={{ fontSize: '0.72rem', padding: '3px 10px', borderRadius: 20, fontWeight: 600, textTransform: 'uppercase', background: estilo.bg, color: estilo.color }}>{c.estado}</span>
                      {alertaVencimiento && <span style={{ fontSize: '0.72rem', padding: '3px 8px', borderRadius: 20, fontWeight: 600, background: '#fef9e7', color: '#f39c12', marginLeft: 4 }}>⚠️ {dias}d</span>}
                    </td>
                    <td>{c.inquilino_nombre} {c.inquilino_apellido}</td>
                    <td style={{ fontWeight: 600 }}>{c.moneda} {parseFloat(c.monto).toLocaleString()}</td>
                    <td style={{ fontSize: '0.85rem' }}>{new Date(c.fecha_inicio).toLocaleDateString('es-UY')}</td>
                    <td style={{ fontSize: '0.85rem' }}>{c.fecha_fin ? new Date(c.fecha_fin).toLocaleDateString('es-UY') : 'Indefinido'}</td>
                    <td style={{ fontSize: '0.85rem', color: '#4f8ef7' }}>{c.inmobiliaria || '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {contratosFiltrados.map(c => {
            const dias = diasParaVencer(c.fecha_fin);
            const alertaVencimiento = c.estado === 'activo' && dias !== null && dias <= 60;
            const estilo = ESTADO_COLORS[c.estado] || ESTADO_COLORS.activo;

            return (
              <div key={c.id} style={{
                background: 'white', borderRadius: 12, padding: '18px 20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                borderLeft: `5px solid ${estilo.color}`,
                cursor: 'pointer'
              }} onClick={() => setDetalle(c)}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6, flexWrap: 'wrap' }}>
                      <h3 style={{ fontSize: '1rem', color: '#1a1a2e' }}>{c.inmueble_nombre}</h3>
                      <span style={{ fontSize: '0.72rem', padding: '3px 10px', borderRadius: 20, fontWeight: 600, textTransform: 'uppercase', background: estilo.bg, color: estilo.color }}>
                        {c.estado}
                      </span>
                      {alertaVencimiento && (
                        <span style={{ fontSize: '0.72rem', padding: '3px 10px', borderRadius: 20, fontWeight: 600, background: '#fef9e7', color: '#f39c12' }}>
                          ⚠️ Vence en {dias} días
                        </span>
                      )}
                      {c.inmobiliaria && (
                        <span style={{ fontSize: '0.72rem', padding: '3px 10px', borderRadius: 20, fontWeight: 600, background: '#eaf2ff', color: '#4f8ef7' }}>
                          🏢 {c.inmobiliaria}
                        </span>
                      )}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '4px 24px', fontSize: '0.86rem', color: '#666' }}>
                      <p>👤 {c.inquilino_nombre} {c.inquilino_apellido}</p>
                      <p>💵 {c.moneda} {parseFloat(c.monto).toLocaleString()}/mes</p>
                      <p>📅 {new Date(c.fecha_inicio).toLocaleDateString('es-UY')} → {c.fecha_fin ? new Date(c.fecha_fin).toLocaleDateString('es-UY') : 'Indefinido'}</p>
                      {c.garante_nombre && <p>🛡 Garantía: {c.garante_nombre}</p>}
                      {c.direccion && <p>📍 {c.direccion}</p>}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right', marginLeft: 20 }}>
                    <div style={{ fontSize: '1.3rem', fontWeight: 700, color: '#1a1a2e' }}>
                      {c.moneda} {parseFloat(c.monto).toLocaleString()}
                    </div>
                    <div style={{ fontSize: '0.78rem', color: '#aaa' }}>por mes</div>
                    {c.duracion_meses && (
                      <div style={{ fontSize: '0.78rem', color: '#aaa', marginTop: 2 }}>{c.duracion_meses} meses</div>
                    )}
                    {c.estado === 'activo' && (
                      <button className="btn btn-secondary" style={{ marginTop: 8, fontSize: '0.78rem', padding: '5px 12px' }}
                        onClick={(e) => { e.stopPropagation(); navigate(`/cuenta-corriente/${c.id}`); }}>
                        Ver cuenta
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* MODAL DETALLE CONTRATO */}
      {detalle && (
        <div className="modal-overlay" onClick={() => setDetalle(null)}>
          <div className="modal" style={{ width: 680 }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div>
                <h2>{detalle.inmueble_nombre}</h2>
                {detalle.inmobiliaria && (
                  <span style={{ fontSize: '0.82rem', color: '#4f8ef7' }}>🏢 {detalle.inmobiliaria}</span>
                )}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn" style={{ fontSize: '0.82rem', background: '#fdecea', color: '#e74c3c' }}
                  onClick={async () => {
                    if (window.confirm(`¿Borrar el contrato de ${detalle.inmueble_nombre}? Esta acción no se puede deshacer.`)) {
                      await contratosService.delete(detalle.id);
                      setDetalle(null);
                      cargar();
                    }
                  }}>
                  🗑 Eliminar
                </button>
                <button className="btn btn-secondary" style={{ fontSize: '0.82rem' }} onClick={() => setDetalle(null)}>✕ Cerrar</button>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 24px', fontSize: '0.88rem', color: '#555', marginBottom: 16 }}>
              <div><strong>Inquilino</strong><br />{detalle.inquilino_nombre} {detalle.inquilino_apellido}</div>
              <div><strong>Contacto</strong><br />{detalle.email || detalle.telefono || '-'}</div>
              <div><strong>Monto</strong><br />{detalle.moneda} {parseFloat(detalle.monto).toLocaleString()}/mes</div>
              <div><strong>Depósito</strong><br />{detalle.moneda_deposito} {detalle.deposito ? parseFloat(detalle.deposito).toLocaleString() : '-'}</div>
              <div><strong>Inicio</strong><br />{new Date(detalle.fecha_inicio).toLocaleDateString('es-UY')}</div>
              <div><strong>Vencimiento</strong><br />{detalle.fecha_fin ? new Date(detalle.fecha_fin).toLocaleDateString('es-UY') : 'Indefinido'}</div>
              <div><strong>Duración</strong><br />{detalle.duracion_meses ? `${detalle.duracion_meses} meses` : '-'}</div>
              <div><strong>Día de pago</strong><br />Primeros {detalle.dia_vencimiento} días del mes</div>
              {detalle.indexacion && detalle.indexacion !== 'ninguna' && (
                <div><strong>Indexación</strong><br />{detalle.indexacion} {detalle.porcentaje_indexacion ? `(${detalle.porcentaje_indexacion}%)` : ''}</div>
              )}
              {detalle.garante_nombre && (
                <div><strong>Garantía</strong><br />{detalle.garante_nombre} {detalle.garante_telefono ? `· ${detalle.garante_telefono}` : ''}</div>
              )}
              {detalle.comision_inmobiliaria && (
                <div><strong>Comisión inmobiliaria</strong><br />{detalle.moneda_comision} {parseFloat(detalle.comision_inmobiliaria).toLocaleString()}</div>
              )}
            </div>

            {detalle.notas && (
              <div style={{ background: '#f8f9fa', borderRadius: 8, padding: '10px 14px', fontSize: '0.85rem', color: '#666', marginBottom: 16 }}>
                📝 {detalle.notas}
              </div>
            )}

            <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '16px 0' }} />
            <Documentos entidadTipo="contrato" entidadId={detalle.id} />
          </div>
        </div>
      )}

      {/* MODAL CARGA MANUAL */}
      {modalManual && (
        <ModalContratoManual
          inmuebles={inmuebles}
          inquilinos={inquilinos}
          garantes={garantes}
          listaInmobiliarias={listaInmobiliarias}
          onClose={() => setModalManual(false)}
          onGuardado={() => { setModalManual(false); cargar(); }}
        />
      )}

      {/* MODAL PASO 1: subir PDF */}
      {pasoIA === 'subir' && (
        <ModalSubirPDF
          onClose={() => setPasoIA(null)}
          onDatosExtraidos={handleDatosExtraidos}
        />
      )}

      {/* MODAL PASO 2: confirmar datos */}
      {pasoIA === 'confirmar' && datosIA && (
        <ModalConfirmar
          datos={datosIA}
          archivo={archivoIA}
          inmuebles={inmuebles}
          listaInmobiliarias={listaInmobiliarias}
          onClose={() => { setPasoIA(null); setDatosIA(null); }}
          onConfirmado={handleConfirmado}
        />
      )}
    </div>
  );
}
